import { useState, useEffect } from 'react';
import { XMarkIcon, ArrowUpTrayIcon } from '@heroicons/react/24/outline';

export const IOSInstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Check if it's iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    // Check if it's Safari (not Chrome or other browsers on iOS)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // Check if already installed (standalone mode)
    const isStandalone = ('standalone' in window.navigator) && (window.navigator as any).standalone;

    // Check if user previously dismissed
    const wasDismissed = localStorage.getItem('iosInstallPromptDismissed');

    // Show prompt if: iOS + Safari + not standalone + not dismissed
    if (isIOS && isSafari && !isStandalone && !wasDismissed) {
      // Delay showing by 2 seconds so it doesn't appear immediately
      const timer = setTimeout(() => {
        setShowPrompt(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('iosInstallPromptDismissed', 'true');
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-cyan-950 text-white p-4 shadow-lg">
      <div className="max-w-lg mx-auto">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <ArrowUpTrayIcon className="h-5 w-5" />
              <h3 className="font-semibold">Install Table Footy</h3>
            </div>
            <p className="text-sm text-gray-200">
              Install this app on your home screen for quick and easy access.
            </p>
            <p className="text-xs text-gray-300 mt-2">
              Tap the <ArrowUpTrayIcon className="inline h-4 w-4 mx-1" /> share button below,
              then select "Add to Home Screen"
            </p>
          </div>
          <button
            onClick={handleDismiss}
            className="flex-shrink-0 p-1 hover:bg-cyan-800 rounded"
            aria-label="Dismiss"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};
